import { swCacheService } from './services/sw-cache.service.js';

/**
 * Created by mqamhieh on 2/3/18.
 */
(function () {

    "use strict";

    angular.module("harriMainApp", [
        "rootApp",
        "harriApp",
        "apiManager",
        "ya.nouislider",
        "harriApp.eVerify",
        "harriApp.rejectionTemplates",
        'harriApp.interviewV2',
        'userActivation',
        "parLabor",
        'hui'
    ]);

   
    swCacheService.registerServiceWorker(['/sw', 'js'].join('.'));

    $(function () {
        /* start-build-remove-block */
        System.import("../compiled/core/harri.js");
        /* end-build-remove-block */
    });

})();
